<template>
  <div class='gift pof w100 h100 t0 l0 zi1000 flex aic jcc lh1' v-if="isShow">
    <div class="gift-img flex aic jcc por" v-if="imgUrl">
      <img :src="imgUrl" alt="" class="h100 csp" @click="giftEvent">
      <div class="gift-close poa r0 csp" @click="close">
        <img src="@/assets/images/close.png" alt="" class="w100">
      </div>
    </div>
    <div v-else-if="type === 'open-vip'" class="open-vip por">
      <div class="open-vip-btns poa flex aic">
        <p class="open-vip-close tac csp" @click="close">狠心取消</p>
        <p class="open-vip-kt tac csp" @click="clickEvent('vip')">立即开通</p>
      </div>
    </div>
    <div v-else-if="type === 'no-power'" class="power ovh">
      <img src="@/assets/images/vip/bgimg.png" alt="" class="w100">
      <div class="flex aic jcc">
        <img src="@/assets/images/vip/round.png" alt="" class="power-icon">
      </div>
      <div class="power-content w100">
        <p class="fs16 power-label">很抱歉，您没有{{+formatiId === 1 ? '观看该视频' : '收听该音频'}}的权限，请开通VIP后再观看！</p>
        <p class="fs12 power-tip">如已开通VIP，请检查所开通的会员学段是否与当前课程年级匹配。</p>
        <p class="power-btn tac csp mlr-auto" @click="close">我知道了</p>
      </div>
    </div>
    <div v-else-if="type === 'pay'" class="pay por ovh">
      <img src="@/assets/images/vip/bgimg.png" alt="" class="w100">
      <div class="sprite-icon close_icon poa csp" @click="close"></div>
      <p class="fs18 pay-tip tac poa">温馨提示</p>
      <p class="pay-label fs16 tac">应版权方要求该课程需付费播放</p>
      <p class="pay-desc tac">购买后可观看完整课程</p>
      <p class="pay-btn tac mlr-auto csp" @click="clickEvent('pay')">立即购买</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ModalGift',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    // 课程类型 1 视频 2 音频
    formatiId: {
      type: String | Number,
      default: 1
    },
    cid: {
      type: Number | String,
      default: ''
    },
		stop:{
			type:Boolean,
			default:false
		}
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data () {
    return {
      isShow: true,
    }
  },
  created () {

  },
  methods: {
    // 点击事件
    giftEvent () {
      if (this.userInfo.uid) {
        this.close();
      } else {
        this.close();
        this.ToLogin();
      }
    },
    // 关闭礼品图
    close () {
      this.isShow = false;
      this.$emit('close-gift');
    },
    clickEvent (prop) {
      this.close();
			if(this.stop){
				this.$emit('check-class')
				return
			}
      this.ShowVip({ type: prop, cid: this.cid });
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';

@df-color: #fff;

.sprite-icon {
  .spirit(url(../../assets/images/user_icons.png));
  &.close_icon {
    top: 6px;
    right: 6px;
    &:after {
      width: 28px;
      height: 27px;
      background-position: -196px -50px;
    }
  }
}

.gift {
  background: rgba(0, 0, 0, 0.7);
  &-close {
    width: 40px;
    height: 40px;
    top: -84px;
  }
  &-img {
    max-width: 504px;
    max-height: 440px;
  }
  .open-vip {
    width: 374px;
    height: 326px;
    background: url(../../assets/images/vip/open_vip.png) no-repeat top left /
      100%;
    &-btns {
      bottom: 25px;
      left: 74px;
      p {
        width: 88px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
      }
    }
    &-close {
      background: #4f5965;
      color: rgba(255, 255, 255, 0.5);
      margin-right: 32px;
      &:hover {
        background: #4b525a;
      }
    }
    &-kt {
      background: linear-gradient(270deg, #ffd491 0%, #ffe2b6 100%);
      color: #b4802c;
      &:hover {
        background: #fdcc81;
        color: #a16c1a;
      }
    }
  }
  .power {
    width: 372px;
    height: 307px;
    background: @df-color;
    border-radius: 8px;
    &-icon {
      width: 74px;
      height: 74px;
      // transform: translateY(-50%);
      margin-top: -37px;
    }
    &-content {
      padding: 0 52px;
    }
    &-label {
      color: #666f7a;
      line-height: 24px;
    }
    &-tip {
      color: #999fa6;
      line-height: 20px;
      padding: 17px 0 40px;
    }
    &-btn {
      width: 118px;
      height: 33px;
      line-height: 33px;
      background: #1177ff;
      border-radius: 17px;
      color: @df-color;
    }
  }
  .pay {
    width: 372px;
    height: 267px;
    background: @df-color;
    border-radius: 8px;
    &-tip {
      font-weight: bold;
      color: @df-color;
      top: 24px;
      left: 50%;
      transform: translateX(-50%);
    }
    &-label {
      color: #333f4e;
      padding: 39px 0 24px;
    }
    &-desc {
      color: #999fa6;
    }
    &-btn {
      width: 118px;
      line-height: 33px;
      background: #1177ff;
      border-radius: 17px;
      color: @df-color;
      margin-top: 47px;
    }
  }
}
</style>
